// Pure helpers for the Packets list (pages/PacketsPage.tsx); no imports so tests/packetFeed.test.mjs
// can run it directly.

export type SourceFilter = "all" | "radio" | "mqtt" | "corescope";

export const SOURCE_FILTERS: { value: SourceFilter; label: string }[] = [
  { value: "all", label: "All" },
  { value: "radio", label: "Our radio" },
  { value: "mqtt", label: "MQTT" },
  { value: "corescope", label: "CoreScope" },
];

// Station names shown in a source cell before "+N".
export const STATIONS_SHOWN = 3;

interface SourceLike {
  kind: string;
  label: string;
  stations?: string[];
  reception_count?: number | null;
}

// "Our radio", an MQTT broker's label, or "CoreScope · <station>, <station> +N (receptions)".
export function sourceChipText(s: SourceLike): string {
  const stations = s.stations ?? [];
  if (s.kind !== "corescope" || stations.length === 0) return s.label;
  const shown = stations.slice(0, STATIONS_SHOWN).join(", ");
  const more = stations.length > STATIONS_SHOWN ? ` +${stations.length - STATIONS_SHOWN}` : "";
  const count = s.reception_count && s.reception_count > 1 ? ` (${s.reception_count})` : "";
  return `${s.label} · ${shown}${more}${count}`;
}

// The paging cursor for the list: the last row's time and id, so rows heard at the same moment
// at a page edge are not skipped.
export function packetCursor(p: { ts?: string | null; id?: string | number | null } | undefined): string | null {
  if (!p || !p.ts) return null;
  return p.id != null ? `${p.ts}|${p.id}` : p.ts;
}

// "<time> · <source>" for a node's Last heard; just the time when the source is not known.
export function lastHeardText(time: string, sourceLabel: string | null | undefined): string {
  return sourceLabel ? `${time} \u00b7 ${sourceLabel}` : time;
}
